import { render, staticRenderFns } from "./feeDetailSub.vue?vue&type=template&id=a1563fc8&scoped=true"
import script from "./feeDetailSub.vue?vue&type=script&lang=js"
export * from "./feeDetailSub.vue?vue&type=script&lang=js"
import style0 from "./feeDetailSub.vue?vue&type=style&index=0&id=a1563fc8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a1563fc8",
  null
  
)

export default component.exports